import {
  ContentEntity,
} from './contentEntity';
import { ContentAttachment } from './valueObjects/contentAttachment';
import { ContentImage } from './valueObjects/contentImage';
import { ContentS3Path } from './valueObjects/contentS3Path';
import { ContentText } from './valueObjects/contentText';

import type {
  ContentJson,
  ContentProps,
} from './contentEntity';

import { Factory } from '@/domain/factory';

export class ContentFactory extends Factory<
  ContentEntity,
  ContentProps,
  ContentJson
> {
  comparePvt = (a: ContentJson, b: ContentJson) => a.s3Path.localeCompare(b.s3Path, 'en');

  createPvt(props: ContentProps): ContentEntity {
    return new ContentEntity(props, null);
  }

  createFromJsonPvt(props: ContentJson): ContentEntity {
    return this.createPvt({
      s3Path: ContentS3Path.create(props.s3Path),
      text: ContentText.create(props.text),
      images: props.images.map((v) => ContentImage.create(v)),
      attachments: props.attachments.map((v) => ContentAttachment.create(v)),
    });
  }
}
